export enum PlayingAge {
  YPPlayingAgeMinYrs = 0,
  YPPlayingAgeMinMth = 6,
  PlayingAgeMinYrs = 3,
  PlayingAgeMaxYrs = 99,
}
